const AmountTypes = Object.freeze({
  PERCENT: 'pc',
  FIXE: 'fixe',
})

export default AmountTypes
